import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  isReady,
  getDevice,
  fetch,
  updateDevice,
  addVolume,
  enableVolume,
  disableVolume,
};

const g_deviceMap: Map<number, any> = new Map();

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done) {
  done && done();
}
function isReady() {
  return true;
}
function getDevice(device_id: number) {
  return g_deviceMap.get(device_id);
}

function fetch(device_id: number, done?: (err: any) => void) {
  const opts = {
    url: `/api/1/admin/device/${device_id}`,
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('DeviceAdminStore.fetch: err:', err);
    } else if (body) {
      g_deviceMap.set(device_id, body);
      _emit('change');
    }
    if (done) {
      done(err);
    }
  });
}
function updateDevice(params, done) {
  const { device_id, ...body } = params;
  const opts = {
    url: `/api/1/admin/device/${device_id}`,
    body,
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('DeviceAdminStore.updateDevice: err:', err, body);
    }
    done(err);
  });
}
function addVolume(params, done) {
  const { device_id, volume_id } = params;
  const opts = {
    url: `/api/1/admin/device/${device_id}/volume/${volume_id}`,
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('DeviceAdminStore.addVolume: err:', err, body);
    }
    done(err);
  });
}
function disableVolume(params, done) {
  const { device_id, volume_id } = params;
  const opts = {
    url: `/api/1/admin/device/${device_id}/volume/${volume_id}/disable`,
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('DeviceAdminStore.disableVolume: err:', err, body);
    }
    done(err);
  });
}
function enableVolume(params, done) {
  const { device_id, volume_id } = params;
  const opts = {
    url: `/api/1/admin/device/${device_id}/volume/${volume_id}/enable`,
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('DeviceAdminStore.enableVolume: err:', err, body);
    }
    done(err);
  });
}
